import NeonStage from "@/components/NeonStage";
import { Reveal } from "./Reveal";

const INSTAGRAM_URL = "https://instagram.com/bulbit.advertising";

export const About = () => {
  return (
    <section id="about" className="relative min-h-[230vh]" data-testid="about-section">
      <div className="pin">
        <NeonStage variant="brain" />
        <div className="text-block relative z-[1] w-full">
          <div className="lg:w-1/2 ml-auto flex flex-col items-start" data-testid="about-content">
            <Reveal>
              <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#EE443E] mb-5">
                Кои сме ние
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2
                className="font-display uppercase text-4xl lg:text-[42px] text-[var(--white)]"
                data-testid="about-headline"
              >
                КРЕАТИВНА АГЕНЦИЯ,<br />ЗАРЕДЕНА С ИДЕИ
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg font-medium leading-snug text-white" data-testid="about-copy">
                От 2016 г. правим едно нещо добре: взимаме идея и я разпалваме докрай — заснемаме кадъра, монтираме видеото, чертаем дизайна, пишем текста, развиваме социалните мрежи.
              </p>
            </Reveal>
            <Reveal delay={0.13}>
              <p className="mt-4 text-lg font-medium leading-snug text-white" data-testid="about-copy-2">
                Един екип, на който можеш да разчиташ за резултати.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-9 inline-flex items-center gap-2 bg-[var(--red)] text-white rounded-full px-7 py-3 text-base font-semibold uppercase tracking-wide hover:opacity-90 transition-opacity"
                data-testid="about-instagram-cta"
              >
                Разгледай работата ни ↗
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
